"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _context = _interopRequireDefault(require("../context"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/*
    Treble Hook
    Gives child components that call it access to store.
*/


var useTreble = function useTreble(context) {
  var trebleContext = context !== undefined ? context : _context["default"];
  return (0, _react.useContext)(trebleContext);
};

var _default = useTreble;
exports["default"] = _default;
module.exports = exports["default"];